import { useEffect } from 'react'
import { BOOKING_STEP } from 'components/BookingModal/constants'

export const usePreselectAvailableTime = ({
  availabilities,
  bookingStep,
  firstAvailability,
  setDisplayedDate,
  setSelectedDate,
  isBookingModalOpen,
}) => {
  useEffect(() => {
    if (bookingStep === BOOKING_STEP.DATETIME_PICKER && firstAvailability) {
      const firstAvailabilityStartAtDate = new Date(
        firstAvailability.startAtUtc.isoFormat
      )
      // Store both dates as raw UTC instants. Conversion into the user's
      // timezone happens only at the picker boundary (see ConsultationsTabContent).
      // Storing an already-zoned displayedDate here caused a double timezone
      // shift in useBookingModalAvailabilitiesQuery, which pushed the month
      // window across a month boundary for large positive UTC offsets
      // (e.g. Asia/Saigon) and returned "No available slots".
      setSelectedDate(firstAvailabilityStartAtDate)
      setDisplayedDate(firstAvailabilityStartAtDate)
    }
  }, [
    bookingStep,
    firstAvailability,
    setDisplayedDate,
    setSelectedDate,
    isBookingModalOpen,
  ])

  useEffect(() => {
    if (
      bookingStep === BOOKING_STEP.DATETIME_PICKER &&
      availabilities.length !== 0
    ) {
      const firstAvailabilityStartAtDate = new Date(
        availabilities[0].startAtUtc.isoFormat
      )
      setSelectedDate(firstAvailabilityStartAtDate)
    }
  }, [availabilities, bookingStep, setSelectedDate, isBookingModalOpen])
}
